import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app';
import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';
import { translations, useAuthenticator } from '@aws-amplify/ui-vue';
import { fetchAuthSession, signOut } from '@aws-amplify/auth';

class AuthHandler {

  $authEnticator = useAuthenticator();

  constructor(endpoint: string, userPoolId: string, clientId: string) {
    
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolEndpoint: endpoint,
          userPoolId: userPoolId,
          userPoolClientId: clientId
        }
      }
    });

    I18n.putVocabularies(translations);
    I18n.putVocabularies({
      ja: {
        'Incorrect username or password.': 'ユーザー名またはパスワードが正しくありません。',
        'Password must have at least 8 characters': 'パスワードは8文字以上である必要があります。',
        'Your passwords must match': 'パスワードが一致しません。',
        'Password did not conform with policy: Password must have lowercase characters': 'パスワードは小文字を含む必要があります。',
        'Password did not conform with policy: Password must have uppercase characters': 'パスワードは大文字を含む必要があります。',
        'Password did not conform with policy: Password must have symbol characters': 'パスワードは記号を含む必要があります。',
      }
    });
    I18n.setLanguage('ja');
  }

  async getToken(refresh: boolean = false): Promise<string | null> {
    try {
      const token = await fetchAuthSession({forceRefresh: refresh});
      if (token.tokens !== undefined) {
        const payload = token.tokens.accessToken.payload;
        const jwt = localStorage.getItem(`CognitoIdentityServiceProvider.${payload.client_id}.${payload.sub}.accessToken`);
        return jwt;
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUser(): any | null {
    return this.$authEnticator.user;
  }

  async logout(): Promise<void> {
    await signOut();
  }

  setRestoreUrl(path: string, query: { [name: string]: string | string[] }) {
    localStorage.setItem('auth.restore.path', path);
    localStorage.setItem('auth.restore.query', JSON.stringify(query));
  }

  getRestoreUrl() {
    const path = localStorage.getItem('auth.restore.path');
    const query = localStorage.getItem('auth.restore.query');
    return {
      path: path === null ? '/mypage' : path,
      query: query === null ? {} : JSON.parse(query)
    };
  }

  clearRestoreUrl() {
    localStorage.removeItem('auth.restore.path');
    localStorage.removeItem('auth.restore.query');
  }

  getRestoreQuery(): { [name: string]: string | string[] } {
    const query = localStorage.getItem('auth.restore.query');
    return query === null ? {} : JSON.parse(query);
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public.cognito;
  const auth = new AuthHandler(
    config.userPoolEndpoint,
    config.userPoolId,
    config.userPoolWebClientId
  );

  return{
    provide: {
      'auth': auth
    }
  };
});